const MINS_IN_HOUR = 60;

export const formatRuntime = (runtime: number | null | undefined) => {
  if (!runtime) {
    return;
  }

  let formattedRuntime = '';
  const hours = Math.floor(runtime / MINS_IN_HOUR);

  if (hours) {
    const hourSuffix = 'h';
    formattedRuntime = `${String(hours)} ${hourSuffix}`;
  }

  const remainingMinutes = runtime % MINS_IN_HOUR;

  if (remainingMinutes) {
    const minSuffix = 'min';
    formattedRuntime = `${formattedRuntime} ${String(remainingMinutes)} ${minSuffix}`;
  }

  return formattedRuntime.trim();
};
